export default __webpack_public_path__ + "static/media/logo-white.5fd84600.png";